import classNames from 'classnames';
import * as React from 'react';
import type { ReactNode } from 'react';
import type { AlertSectionVariant } from '~/Blocks/AlertSectionBlock/AlertSectionVariant.csharp';
import type { HtmlString } from '~/Features/Types/HtmlString.csharp';
import { AlertSection } from '~/Partials/AlertSection/AlertSection';
import { HtmlDiv } from '~/Partials/Controls/HtmlDiv';
import { isHtmlString } from '~/Partials/Controls/Utils/isHtmlString';
import styles from './StudyPageInfoBox.module.css';

export interface StudyPageInfoBoxProps {
    header: string;
    variant: AlertSectionVariant;
    body?: HtmlString | ReactNode;
}

export const StudyPageInfoBox: React.FC<StudyPageInfoBoxProps> = props => {
    const { header, body, variant } = props;

    const renderBody = () => {
        if (isHtmlString(body)) {
            return (
                <HtmlDiv
                    html={body}
                    className={classNames(styles.Content, 'RichtextContent', `RichtextContent--dark`)}
                />
            );
        }

        if (body) {
            return <div className={classNames(styles.Content, 'RichtextContent', `RichtextContent--dark`)}>{body}</div>;
        }
    };

    return (
        <div className={styles.StudyPageInfoBox}>
            <AlertSection header={header} variant={variant}>
                {renderBody()}
            </AlertSection>
        </div>
    );
};
